module.exports = "pegasus_template/assets/column-8-basic.png";